const BUSINESS_TYPES = [
  {
    label: "Kupiec rolny / Sklep rolniczy",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Schronisko dla zwierząt / Organizacja charytatywna",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Teren tuczu podstawowego",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Producent wołowiny",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Brojlery", value: "Broilers", id: "broilers" },
  {
    label: "Grupa zakupowa",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Produkcja cieląt",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Farma cieląt / Deweloper",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Nabywca bydła", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Hodowca kontraktowy",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Spółdzielnia", value: "Cooperative", id: "cooperative" },
  {
    label: "Biuro korporacyjne",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Hodowla krów z cielętami",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Produkcja mleczna",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Dystrybutor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Młyn paszowy", value: "Feed Mill", id: "feed_mill" },
  { label: "Teren tuczu", value: "Feedyard", id: "feedyard" },
  {
    label: "Hodowca / Teren hodowlany",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Wylęgarnia", value: "Hatchery", id: "hatchery" },
  {
    label: "Produkcja jałówek",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Integracja kur niosek",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Kury nioski", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Spółdzielnia mleczna / Nabywca",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Producent mieszany / Inny",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Dostawca składników odżywczych",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Pakujący / Przetwórca",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Punkt sprzedaży zwierząt domowych",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Apteka", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Hodowca drobiu",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Integrator drobiu",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Producent owiec", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Operacja magazynowa",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Giełda bydła / Hala sprzedaży",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  {
    label: "Producent trzody chlewnej",
    value: "Swine Producer",
    id: "swine_producer",
  },
  { label: "Indyki", value: "Turkeys", id: "turkeys" },
  {
    label: "Uniwersytet / Edukacja",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Praktyka weterynaryjna",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Hurtownik / Detalista",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Nabywca wełny", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Wymagane",
    },
  },
  salutation: {
    label: "Forma zwrotu",
    placeholder: "Wybierz formę zwrotu",
    errors: {
      required: "Forma zwrotu jest wymagana",
      invalid: "Proszę wybrać prawidłową formę zwrotu",
    },
  },
  firstName: {
    label: "Imię",
    placeholder: "Jan",
    errors: {
      authenticatedNameUpdateTrial:
        "Jesteś zalogowany(-a) i nie możesz zmienić swojego imienia i nazwiska.",
      required: "Imię jest wymagane",
      minLength: "Imię musi mieć co najmniej 2 znaki",
      maxLength: "Imię nie może przekraczać 50 znaków",
    },
  },
  lastName: {
    label: "Nazwisko",
    placeholder: "Kowalski",
    errors: {
      authenticatedNameUpdateTrial:
        "Jesteś zalogowany(-a) i nie możesz zmienić swojego imienia i nazwiska.",
      required: "Nazwisko jest wymagane",
      minLength: "Nazwisko musi mieć co najmniej 2 znaki",
      maxLength: "Nazwisko nie może przekraczać 50 znaków",
    },
  },
  email: {
    label: "E-mail",
    placeholder: "jan.kowalski@example.org",
    description:
      "Proszę podać osobisty adres e-mail, a nie adres współdzielony.",
    prefixWarningTitle: "Wykryto współdzieloną skrzynkę pocztową",
    prefixWarningDescription:
      "Zalecamy użycie osobistego adresu e-mail dla lepszych doświadczeń spersonalizowanych",
    errors: {
      authenticatedEmailUpdateTrial:
        "Jesteś zalogowany(-a) i nie możesz zmienić swojego adresu e-mail.",
      required: "E-mail jest wymagany",
      invalidEmail: "Proszę podać prawidłowy adres e-mail",
      emailAssociatedWithYourAccount:
        "Twój adres e-mail jest powiązany z Twoim kontem i nie może zostać zmieniony.",
    },
  },
  confirmEmail: {
    label: "Potwierdź e-mail",
    placeholder: "jan.kowalski@example.org",
    errors: {
      authenticatedEmailUpdateTrial:
        "Jesteś zalogowany(-a) i nie możesz zmienić swojego adresu e-mail.",
      required: "Potwierdzenie e-maila jest wymagane",
      invalidEmail: "Proszę podać prawidłowy adres e-mail",
      emailMatchError: "Adresy e-mail nie pasują do siebie",
    },
  },
  password: {
    label: "Hasło",
    placeholder: "Wprowadź swoje hasło",
    errors: {
      required: "Hasło jest wymagane",
    },
  },
  confirmPassword: {
    label: "Potwierdź hasło",
    placeholder: "Potwierdź swoje hasło",
    errors: {
      required: "Potwierdzenie hasła jest wymagane",
      passwordMatchError: "Hasła nie pasują do siebie",
    },
  },
  addressLine1: {
    label: "Adres linia 1",
    placeholder: "ul. Główna 123",
    errors: {
      required: "Adres linia 1 jest wymagany",
      minLength: "Adres linia 1 musi mieć co najmniej 5 znaków",
      maxLength: "Adres linia 1 nie może przekraczać 100 znaków",
    },
  },
  addressLine2: {
    label: "Adres linia 2",
    placeholder: "Mieszkanie 4B",
    errors: {
      required: "Adres linia 2 jest wymagany",
      maxLength: "Adres linia 2 nie może przekraczać 100 znaków",
    },
  },
  city: {
    label: "Miasto / Miejscowość",
    placeholder: "Warszawa",
    errors: {
      required: "Miasto / Miejscowość jest wymagane",
      minLength: "Miasto / Miejscowość musi mieć co najmniej 2 znaki",
      maxLength: "Miasto / Miejscowość nie może przekraczać 50 znaków",
    },
  },
  country: {
    label: "Kraj",
    placeholder: "Wybierz kraj",
    errors: {
      required: "Kraj jest wymagany",
      invalid: "Wybierz prawidłowy kraj",
    },
  },
  state: {
    label: "Województwo",
    placeholder: "Wybierz województwo",
    errors: {
      required: "Województwo jest wymagane",
      invalid: "Proszę wybrać prawidłowe województwo",
    },
  },
  jurisdiction: {
    label: "Jurysdykcja licencji",
    placeholder: "Wybierz jurysdykcję licencji",
    errors: {
      required: "Jurysdykcja licencji jest wymagana",
      invalid: "Proszę wybrać prawidłową jurysdykcję",
    },
  },
  zipCode: {
    label: "Kod pocztowy",
    placeholder: "00-001",
    errors: {
      required: "Kod pocztowy jest wymagany",
      invalid: "Proszę podać prawidłowy kod pocztowy",
    },
  },
  role: {
    label: "Rola",
    placeholder: "Wybierz swoją rolę",
    errors: {
      required: "Proszę wybrać swoją rolę",
      invalid: "Proszę wybrać prawidłową rolę",
    },
  },
  businessType: {
    label: "Typ działalności",
    placeholder: "Wybierz typ działalności",
    errors: {
      required: "Typ działalności jest wymagany",
      invalid: "Proszę wybrać prawidłowy typ działalności",
    },
  },
  businessName: {
    label: "Nazwa firmy",
    placeholder: "Wprowadź nazwę firmy",
    errors: {
      required: "Nazwa firmy jest wymagana",
      minLength: "Nazwa firmy musi mieć co najmniej 2 znaki",
      maxLength: "Nazwa firmy nie może przekraczać 100 znaków",
    },
  },
  businessSearch: {
    label: "Wyszukiwanie firm:",
    addNewAccount: "Dodaj nowe konto firmowe",
    canNotFindBusiness: "Nie możesz znaleźć swojej firmy?",
    guideline:
      "Proszę wprowadzić kod pocztowy, a następnie wybrać z listy poniżej.",
    guidelineForNameSearch:
      "Proszę podać pełną nazwę firmy, a następnie wybrać z listy.",
    placeholder: "Gdzie pracujesz?",
    noResults: "Nie znaleziono wyników",
    searching: "Wyszukiwanie...",
    selectedBusinessHeading: "Wybrana firma:",
    selectedBusinessNotCorrect: "Nieprawidłowe?",
    selectedBusinessTryAgain: "Spróbuj ponownie",
    selectedBusinessDismiss: "Odrzuć firmę",
    resultsFound: {
      singular: "Znaleziono 1 firmę",
      plural: "Znaleziono wiele firm",
    },
    errors: {
      network:
        "Mamy problemy z połączeniem z wyszukiwarką firm. Proszę spróbować później.",
    },
  },
  explicitConsent: {
    label:
      "Zaznaczając to pole, zgadzam się na Warunki użytkowania Elanco, potwierdzam, że Elanco będzie zbierać i przetwarzać moje dane osobowe zgodnie z Polityką prywatności Elanco",
    errors: {
      required: "Zgoda e-mail jest wymagana",
    },
  },
  explicitSmsConsent: {
    label:
      "Zaznaczając to pole, wyrażam zgodę na otrzymywanie komunikatów marketingowych od firmy Elanco za pośrednictwem wiadomości SMS/tekstowych.",
    errors: {
      required: "Zgoda na SMS jest wymagana",
    },
  },
  telephone: {
    label: "Telefon osobisty",
    placeholder: "Wprowadź swój telefon osobisty",
    dialCodeLabel: "Kod",
    dialCodePlaceholder: "Szukaj kraju…",
    errors: {
      invalid: "Proszę podać prawidłowy numer telefonu.",
    },
  },
  businessTelephone: {
    label: "Telefon firmowy",
    placeholder: "Wprowadź swój telefon firmowy",
    dialCodeLabel: "Kod",
    dialCodePlaceholder: "Szukaj kraju…",
    errors: {
      invalid: "Proszę podać prawidłowy numer telefonu.",
    },
  },
  professionalNumber: {
    label: "Numer zawodowy",
    placeholder: "1234567",
    errors: {
      required: "Proszę podać numer zawodowy",
      maxLength: "Przekroczono limit znaków",
    },
  },
  addressSearch: {
    errors: {
      required: "To pole jest wymagane",
    },
  },
  businessSearchField: {
    errors: {
      required: "To pole jest wymagane",
    },
  },
  checkbox: {
    errors: {
      required: "To pole jest wymagane",
    },
  },
  checkboxGroup: {
    errors: {
      required: "To pole jest wymagane",
    },
  },
  combobox: {
    errors: {
      required: "To pole jest wymagane",
    },
  },
  datePicker: {
    errors: {
      required: "To pole jest wymagane",
    },
  },
  dateRange: {
    errors: {
      required: "To pole jest wymagane",
    },
  },
  dateTime: {
    errors: {
      required: "To pole jest wymagane",
    },
  },
  emailField: {
    errors: {
      required: "To pole jest wymagane",
    },
  },
  fileInput: {
    errors: {
      required: "Proszę wybrać plik",
    },
  },
  number: {
    errors: {
      required: "Proszę podać liczbę",
      minValue: "Proszę podać wartość wyższą niż minimum",
      maxValue: "Proszę podać wartość niższą niż maksimum",
    },
  },
  passwordField: {
    errors: {
      required: "To pole jest wymagane",
    },
  },
  rangeSlider: {
    errors: {
      required: "To pole jest wymagane",
    },
  },
  select: {
    errors: {
      required: "To pole jest wymagane",
    },
  },
  telephoneField: {
    errors: {
      required: "Proszę wprowadzać tylko cyfry",
      invalidTelephone: "Proszę podać prawidłowy numer telefonu",
      invalidFormat: "Nieprawidłowy format numeru",
    },
  },
  text: {
    errors: {
      required: "Proszę używać tylko liter (A-Z), cyfr (0-9) i bez symboli",
      maxLength: "Przekroczono limit znaków",
      minLength: "Wprowadzony tekst musi mieć co najmniej 2 znaki",
    },
  },
  textarea: {
    characters: "znaków",
  },
  time: {
    errors: {
      required: "To pole jest wymagane",
    },
  },
  form: {
    errors: {
      generic:
        "Napotkaliśmy błąd podczas przesyłania formularza. Proszę spróbować ponownie.",
      reportAnIssue: "Proszę zgłosić problem.",
      configuration: "Błąd konfiguracji",
      noFormQuestionsAvailable: "Brak dostępnych pytań w formularzu.",
      formComponentLoad:
        "Nie można załadować komponentu formularza z powodu nieobsługiwanego pola.",
      code: "Kod",
      type: "Typ",
      missingRequiredFields:
        "W tym formularzu brakuje wymaganych pól (E-mail i/lub Zgoda). Proszę skontaktować się z administratorem w celu naprawienia konfiguracji formularza.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Naukowiec", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Dobr Stan Zwierząt - Inne",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Dobro Zwierząt - Personel sprzedaży",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Dobro Zwierząt - Weterynarz",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Dobro Zwierząt - Pielęgniarka weterynaryjna",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Dobro Zwierząt - Wolontariusz",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Rozszerzenie dla bydła / tuczu",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Producent wołowiny",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Hodowca", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Administrator biznesowy / Recepcjonista",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Właściciel firmy / Partner",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Konsultant ds. żywienia",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Pracownik korporacyjny weterynarii (poza szpitalem)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Producent mleczny",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Dystrybutor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Przedstawiciel dystrybutora, Terenowy",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Przedstawiciel dystrybutora, Biurowy",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Instytucja edukacyjna - Uczeń szkoły średniej",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Instytucja edukacyjna - Student TAFE",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Instytucja edukacyjna - Student uniwersytetu",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Dyrektor medyczny / kliniki",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Sprzedaż żywienia / pasz",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Specjalista ds. żywienia",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Dietetyk", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Kierownik biura / praktyki",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "Sprzedawca OTC", id: "otc_retailer" },
  { value: "Pharmacist", label: "Farmaceuta", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Apteka - Personel",
    id: "pharmacy_staff",
  },
  {
    value: "Pig Producer",
    label: "Producent trzody chlewnej",
    id: "pig_producer",
  },
  {
    value: "Poultry Producer",
    label: "Producent drobiu",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Właściciel praktyki, Nie-DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Recepcjonista / Obsługa klienta",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Sklep dystrybutora - Personel",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Producent - Mieszany/Inny",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Sprzedawca detaliczny",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Hodowca owiec",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Lekarz weterynarii",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trener", id: "trainer" },
  { value: "Veterinarian", label: "Weterynarz", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Weterynarz, Właściciel praktyki",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Asystent weterynaryjny",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Pielęgniarka weterynaryjna",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Praktyka weterynaryjna - Inne",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Praktyka weterynaryjna - Weterynarz",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Praktyka weterynaryjna - Pielęgniarka weterynaryjna",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Specjalista weterynarii",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Student weterynarii",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Chirurg weterynarii",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Technik weterynarii",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Hurtownik", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Pan",
    value: "M.",
    id: "m",
  },
  {
    label: "Panna",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Pan",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Pani",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Pani",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Profesor",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
